// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + chunkId + ".js?id=" + {"node_modules_dompurify_dist_purify_js":"7c7c19577c7f5865","node_modules_canvg_lib_index_es_js":"8e7df62861059eda"}[chunkId] + "";
};